import {makeAutoObservable} from "mobx";


export default class CommonStore {

    constructor(props) {
        this.isLoading = false;
        this.loadingText = '';

        this.sideMenuTab = 0;

        makeAutoObservable(this);
    }

    initLoadingState = () => {
        this.isLoading = false;
        this.loadingText = '';
    };

    setLoadingState = (loadingText) => {
        this.isLoading = true;
        if (loadingText) {
            this.loadingText = loadingText;
        }
    };

    setSideMenuTab = (tab) => {
        this.sideMenuTab = tab;
    }
}

